import { Trans } from '@lingui/react/macro'
import { TickDouble01Icon } from '@hugeicons/core-solid-rounded'

import Button from '@/components/ui/Button'
import Loading from '@/components/ui/Loading'
import { useFeedbacks } from '../hooks/useFeedbacks'
import { FeedbackTile } from './FeedbackTile'
import { useMarkAllAsRead } from '../hooks/useMarkAllAsRead'

export function Feedbacks() {
  const { items, loading, loadMore, canLoadMore } = useFeedbacks()
  const { markAllAsRead, loading: loadingMarkAllAsRead } = useMarkAllAsRead()

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="flex flex-row justify-between items-center px-4 py-1">
        <h1 className="text-text text-heading1">
          <Trans>Feedbacks</Trans>
        </h1>
        <Button
          Icon={TickDouble01Icon}
          onClick={markAllAsRead}
          loading={loadingMarkAllAsRead}
        >
          <Trans>Mark all as Read</Trans>
        </Button>
      </div>
      <div className="flex flex-col gap-4 overflow-auto flex-1 pb-10 px-4">
        {items.map(item => (
          <FeedbackTile item={item} key={item.id} />
        ))}
        {loading && (
          <div className="flex flex-row items-center justify-center h-8">
            <Loading />
          </div>
        )}
        {canLoadMore && !loading && (
          <div className="flex flex-row w-full justify-center">
            <Button onClick={loadMore}>
              <Trans>Load more</Trans>
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
